<script setup lang="ts">
import Button from '@/components/ui/BtnComp.vue';
import ModalLayout from '@/layouts/ModalLayout.vue';
import { useStore } from '@/store/store.ts';
import EditableArea from '@/components/ui/EditableArea.vue';
import { useRouter } from 'vue-router';
import { computed, onBeforeUnmount } from 'vue';

const props = withDefaults(defineProps<{
  sectionName: string,
}>(), 
{
  sectionName: '',
});
const store = useStore();
const router = useRouter();

const chapter = computed(() => {
  return props.sectionName || String(router.currentRoute.value.name || '');
});

function sendMessage(){
  store.sendImproveMessage(chapter.value)
}

onBeforeUnmount(() => {
  store.improveArea.isError = false;
  store.improveArea.isRepeatError = false;
});
</script>

<template>
  <ModalLayout :name_modal="'improve'" :icon_name="'question'">
    <div class="success" v-if="store.improve_success">
      <h3>Ваша заявка принята!</h3>
      <div class="content">
        <p>В ближайшее время мы её рассмотрим и если это возможно, сделаем по красоте :)</p>
        <Button @click="store.closeModal('improve')">Огонь!</Button>
      </div>
    </div>
    <div class="improve" v-else>
      <div class="content">
        <h3>Задайте вопрос или предложите улучшение</h3>
        <p>
          Если вы хотите, чтобы мы с вами связались и&nbsp;подробно опросили — дополнительно оставьте контакты и&nbsp;удобный способ связи
        </p>
        <EditableArea
          class="improve_area"
          v-bind="store.improveArea"
          v-model="store.improveArea.modelValue"
          :location="store.improveArea"
        />
        <Button
          :isLoad="store.isImproveLoading"
          @click="sendMessage()"
          >Отправить</Button
        >
      </div>
    </div>
  </ModalLayout>
</template>

<style lang="scss" scoped>
.improve,
.success {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 704px;
  .improve_area {
    margin-top: 64px;
  }
  .materials-btn {
    width: auto;
    padding: 14px 64px;
    border-radius: 120px;
    margin-top: 64px;
    text-transform: none;
    height: auto;
    font-size: 28px;
    font-family: 'SFProDisplay', sans-serif;
    line-height: 36px;
    font-weight: 300;
    background-color: #A99D91;
    &:hover {
      background-color: #BAA896;
    }
    &:active {
      background-color: #A49383;
    }
  }
  h3 {
    font-style: normal;
    font-family: 'SFProDisplay', sans-serif;
    font-weight: 300;
    font-size: 56px;
    line-height: 68px;
    color: var(--black);
    width: 704px;
    text-align: center;
  }
  p {
    width: 704px;
    font-style: normal;
    font-family: 'SFProDisplay', sans-serif;
    font-weight: 300;
    font-size: 20px;
    line-height: 24px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
    margin-top: 12px;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 704px;
  }
}
.success {
  p {
    width: 475px;
  }
}
@include for-mobile {
  .improve,
  .success {
    width: 100%;
    padding: 0 12px;
    .improve_area {
      width: 100%;
      margin-top: 0;
    }
    .materials-btn {
      width: 100%;
      padding: 18px 0;
      font-size: 18px;
      line-height: 20px;
      margin-top: 40px;
    }
    h3 {
      width: 100%;
      text-align: center;
      font-size: 40px;
      line-height: 48px;
    }
    p {
      width: 100%;
      font-size: 16px;
      line-height: 20px;
      display: block;
      text-align: center;
    }
    .content {
      width: 100%;
    }
  }
  .success {
    p {
      min-width: 336px;
      font-size: 16px;
      line-height: 20px;
      display: block;
      text-align: center;
    }
    h3 {
      margin-bottom: 0;
      font-size: 40px;
      line-height: 48px;
    }
  }
}
</style>
